import { render, staticRenderFns } from "./PetDialog.vue?vue&type=template&id=7853fbfa&"
import script from "./PetDialog.vue?vue&type=script&lang=js&"
export * from "./PetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports